export default __webpack_public_path__ + "static/media/instagram.f7f81aaa.svg";